module.exports = __webpack_public_path__ + "50c48638e4b13947c0b0893e3c4e2349.MP3";